// Copyright (c) 2017 PlanGrid, Inc.

import React from 'react';

//import LogoRegione from '../../assets/logo-regione.png';

export default () => (
  <div style={{ textAlign: 'center' }}>
    {/* <img src={LogoRegione} width={80} className="m10h" /> */}
    <h3 className="sectionTitle">SILF</h3>
  </div>
)
